import { Outlet } from "react-router-dom";

/** Studio routes — padding and max width come from {@link PageContainer} in AuthenticatedLayout. */
export function StudioLayout() {
  return <Outlet />;
}
